import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { I18nModule } from '@spartacus/core'
import { SpinnerModule } from '@spartacus/storefront'
import { InfiniteScrollModule } from 'ngx-infinite-scroll'
import { EbSpinnerModule } from '../spinner/eb-spinner.module'
import { EbLoadMoreButtonComponent } from './eb-load-more-button.component'

@NgModule({
  imports: [CommonModule, InfiniteScrollModule, SpinnerModule, EbSpinnerModule, I18nModule],
  declarations: [EbLoadMoreButtonComponent],
  exports: [EbLoadMoreButtonComponent]
})
export class EbLoadMoreButtonModule {}
